import type { SvgIconComponent } from '@mui/icons-material';
import {
  CheckCircle,
  Cancel,
  PlaylistAdd,
  Replay,
  Refresh,
  Info,
} from '@mui/icons-material';
import { Box } from '@mui/material';
import type { PlotEventType } from '../../../types/plotTimeline';

interface IconConfig {
  Icon: SvgIconComponent;
  color: string;
}

const cancelError: IconConfig = { Icon: Cancel, color: 'error.main' };

const iconConfig: Record<PlotEventType, IconConfig> = {
  AllocationBooked: { Icon: PlaylistAdd, color: 'primary.main' },
  AllocationApproved: { Icon: CheckCircle, color: 'success.main' },
  AllocationRejected: cancelError,
  AllocationCancelled: { Icon: Cancel, color: 'warning.main' },
  AllocationAdminCancelled: cancelError,
  AllocationRebooked: { Icon: Replay, color: 'info.main' },
  AllocationResubmitted: { Icon: Refresh, color: 'info.main' },
};

const defaultIcon: IconConfig = { Icon: Info, color: 'text.secondary' };

export interface EventIconProps {
  eventType: PlotEventType;
  size?: 'small' | 'medium';
}

export function EventIcon({ eventType, size = 'medium' }: EventIconProps) {
  const iconSize = size === 'small' ? 20 : 24;
  const { Icon, color } = iconConfig[eventType] ?? defaultIcon;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color,
      }}
    >
      <Icon sx={{ fontSize: iconSize }} />
    </Box>
  );
}
